import { ComponentProps } from "react";
import { LucideIcon, UserRoundPlus } from "lucide-react";
import { Button } from "~/components/ui/button";
import { cn } from "~/lib/utils";

interface ShareButtonProps extends ComponentProps<typeof Button> {
  label?: string;
  icon?: LucideIcon;
}

/**
 * Shared, high-visibility share control for projects / datasets / agents.
 * Purple outline so it stands out against the workspace instead of fading in
 * like the neutral outline button did.
 */
export function ShareButton({
  label = "Share",
  icon: Icon = UserRoundPlus,
  className,
  ...props
}: ShareButtonProps) {
  return (
    <Button
      variant="outline"
      size="sm"
      className={cn(
        "border-primary text-primary hover:bg-primary/10 hover:text-primary text-xs",
        className
      )}
      {...props}
    >
      <Icon className="size-4" />
      {label}
    </Button>
  );
}
